<div class="auth">
  <div class="auth__glow" aria-hidden="true"></div>

  <header class="auth__top">
    <a routerLink="/" class="auth-brand" aria-label="PulseWatch home">
      <span class="auth-brand__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64"><path d="M9 35h11l5-12 8 24 6-17 3 5h13" /></svg>
      </span>
      <span class="auth-brand__name">PulseWatch</span>
    </a>
    <a routerLink="/knowledge-base" class="auth__help">Help</a>
  </header>

  <main class="auth__main auth__main--single">
    <section class="auth-card">
      @switch (state()) {
        @case ('done') {
          <div class="auth-success" role="status" data-testid="reset-done">
            <div class="auth-success__icon"><i class="bx bx-check-circle"></i></div>
            <h1>Password changed</h1>
            <p>You can now log in with your new password.</p>
          </div>
          <a routerLink="/login" class="auth-btn" data-testid="reset-login">Log in <i class="bx bx-right-arrow-alt"></i></a>
        }
        @case ('invalid') {
          <div class="auth-success" role="alert" data-testid="reset-invalid">
            <div class="auth-success__icon"><i class="bx bx-link-alt"></i></div>
            <h1>This link doesn't work anymore</h1>
            <p>Reset links expire after an hour and work only once. Request a new one and use the latest email.</p>
          </div>
          <a routerLink="/forgot-password" class="auth-btn">Request a new link <i class="bx bx-right-arrow-alt"></i></a>
        }
        @case ('disabled') {
          <div class="auth-success" role="alert" data-testid="reset-disabled">
            <div class="auth-success__icon"><i class="bx bx-lock-alt"></i></div>
            <h1>Password resets are turned off</h1>
            <p>Resetting passwords is not possible at the moment. Please contact support.</p>
          </div>
          <a routerLink="/login" class="auth-btn auth-btn--ghost">Back to log in</a>
        }
        @default {
          <h1>Choose a new password</h1>
          <p class="auth-card__sub">At least 5 characters, with a letter and a number.</p>

          <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <label class="auth-field">
              <span>New password</span>
              <div class="auth-field__box" [class.is-invalid]="passwordInvalid">
                <i class="bx bx-lock-alt" aria-hidden="true"></i>
                <input
                  [type]="showPassword() ? 'text' : 'password'"
                  formControlName="password"
                  autocomplete="new-password"
                  data-testid="reset-password"
                />
                <button
                  type="button"
                  class="auth-field__toggle"
                  (click)="showPassword.set(!showPassword())"
                  [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                >
                  <i class="bx" [class.bx-show]="!showPassword()" [class.bx-hide]="showPassword()"></i>
                </button>
              </div>
              @if (has('password', 'required')) {
                <small class="auth-field__error">Password is required.</small>
              } @else if (has('password', 'minlength')) {
                <small class="auth-field__error">Password must be at least 5 characters.</small>
              } @else if (has('password', 'maxlength')) {
                <small class="auth-field__error">Password can be at most 24 characters.</small>
              } @else if (has('password', 'passwordNoLetter')) {
                <small class="auth-field__error">Password must contain at least one letter.</small>
              } @else if (has('password', 'passwordNoNumber')) {
                <small class="auth-field__error">Password must contain at least one number.</small>
              }
              @if (passwordError(); as message) {
                <small class="auth-field__error" data-testid="reset-password-error">{{ message }}</small>
              }
            </label>

            <label class="auth-field">
              <span>Repeat new password</span>
              <div class="auth-field__box" [class.is-invalid]="has('confirm', 'required') || mismatch">
                <i class="bx bx-lock-alt" aria-hidden="true"></i>
                <input
                  [type]="showPassword() ? 'text' : 'password'"
                  formControlName="confirm"
                  autocomplete="new-password"
                  data-testid="reset-confirm"
                />
              </div>
              @if (has('confirm', 'required')) {
                <small class="auth-field__error">Please repeat the password.</small>
              } @else if (mismatch) {
                <small class="auth-field__error" data-testid="reset-mismatch">The passwords don't match.</small>
              }
            </label>

            @if (formError()) {
              <div class="auth-alert" role="alert"><i class="bx bx-error-circle"></i>{{ formError() }}</div>
            }

            <button type="submit" class="auth-btn" [disabled]="isLoading()" data-testid="reset-submit">
              @if (isLoading()) {
                <span class="auth-btn__spinner" aria-hidden="true"></span> Saving…
              } @else {
                Save new password <i class="bx bx-right-arrow-alt"></i>
              }
            </button>
          </form>

          <p class="auth-card__alt">Remembered it? <a routerLink="/login" class="auth-link">Back to log in</a></p>
        }
      }
    </section>
  </main>

  <footer class="auth__footer">{{ versions.hash }} · {{ versions.date | date: 'short' }}</footer>
</div>
